var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAnnouncement = function SvgAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27273 11.9994C6.27273 11.5475 6.63904 11.1812 7.09091 11.1812H14.4545C14.9064 11.1812 15.2727 11.5475 15.2727 11.9994C15.2727 12.4513 14.9064 12.8176 14.4545 12.8176H7.09091C6.63904 12.8176 6.27273 12.4513 6.27273 11.9994Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09091 14.454C6.63904 14.454 6.27273 14.8203 6.27273 15.2721C6.27273 15.724 6.63904 16.0903 7.09091 16.0903H10.3636C10.8155 16.0903 11.1818 15.724 11.1818 15.2721C11.1818 14.8203 10.8155 14.454 10.3636 14.454H7.09091Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5786 4.46632C12.259 4.1468 11.741 4.1468 11.4215 4.46632L8.38839 7.49941H4.63636C3.73262 7.49941 3 8.23204 3 9.13578V18.1358C3 19.0395 3.73262 19.7721 4.63636 19.7721H19.3636C20.2674 19.7721 21 19.0395 21 18.1358V9.13578C21 8.23204 20.2674 7.49941 19.3636 7.49941H15.6117L12.5786 4.46632ZM13.2975 7.49941L12 6.20195L10.7026 7.49941H13.2975ZM4.63636 9.13578V18.1358H19.3636V9.13578H4.63636Z",
    fill: "currentColor"
  })));
};

export { SvgAnnouncement as ReactComponent };
export default __webpack_public_path__ + "f0b2fd753da4d6f10bfe7316ac13401e.svg";